import { ThreeByFourCardStack } from './three-by-four-card-stack';
import { Type } from '@angular/core';
import { GlassHouseBrandGroupThreeByFourStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-3x4/glass-house-brand-group-three-by-four-stack-background/glass-house-brand-group-three-by-four-stack-background.component';
import { GlassHouseBrandGroupThreeByFourStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-3x4/glass-house-brand-group-three-by-four-stack-content/glass-house-brand-group-three-by-four-stack-content.component';
import type { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import type { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import type { GlassHouseBrandGroupCardData } from '../../../../print-cards/glass-house/glass-house-brand-group-card-data';

export class GlassHouse3x4CardStack extends ThreeByFourCardStack {
  getCardBackgroundComponent(cardData: GlassHouseBrandGroupCardData): Type<CardBackgroundComponent> {
    return GlassHouseBrandGroupThreeByFourStackBackgroundComponent;
  }

  getCardContentComponent(cardData: GlassHouseBrandGroupCardData): Type<PrintCardContentComponent> {
    return GlassHouseBrandGroupThreeByFourStackContentComponent;
  }

  override nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
